//-----------------------------------------------------------------------
// Copyright © 2023 ManpowerGroup. All Rights Reserved.
//-----------------------------------------------------------------------
import React, { useState, useRef, useEffect, useMemo } from 'react';
import 'ag-grid-community/styles/ag-grid.css'; // Core grid CSS, always needed
import 'ag-grid-community/styles/ag-theme-alpine.css'; // Optional theme CSS
import ReactPaginate from 'react-paginate';
import { saveAs } from 'file-saver';
import DownlodIcon from '../../../assets/images/DownlodIcon.png';
import ClockIcon from '../../../assets/images/clockIcon.png';
import CheckIcon from '../../../assets/images/checkIcon.png';
import DenyIcon from '../../../assets/images/rejectedIcon.png';
import InfoIcon from '../../../assets/images/info.png';
import RightArrowPaginate from '../../../assets/images/RightArrowPaginate.png';
import LeftArrowPaginate from '../../../assets/images/LeftArrowPaginate.png';
import { customDateConverter, xxlDataForReferral, normalDataForReferral } from '../../../helpers/constants';
import CustomTooltip from '../../../components/common/Grid/tooltip/Tooltip';
import httpHelper from '../../../helpers/HttpHelper';
import environments from '../../common/environments/environments'; // eslint-disable-line
import { ReferralsActions } from '../ReferralsActions';
import Loader from '../../common/Loader';
import InLineLoader from '../../common/inlineLoader';
import Grid from '../../../components/common/Grid';
import '../../common/Pagination/pagination.scss';
import PopupLoading from '../../../helpers/popuploading';
import Spinner from '../../common/spinner';
import Modalpopup from '../../common/Modal/Modalpopup';
import TextArea from '../../common/textArea';
import Button from '../../common/button';
import imgCloseButton from '../../../assets/images/btn-close.png';
//import Snackbar from '../../../components/common/snackBar/SnackBar';
//import SnackbarContext from '../../../components/common/snack';
import useScreenSize from '../../../helpers/userScreensize';
export default function MySubmittedRequests(props) {
	const screenSize = useScreenSize(); //eslint-disable-line
	//const snackbarCtx = useContext(SnackbarContext);
	const refgridRef = useRef();
	const shouldLog = useRef(true);
	const http = new httpHelper(); // eslint-disable-line
	const [columnDefs, setColumnDefs] = useState();
	const [pageSize, setPageSize] = useState(10); /* eslint-disable-line */
	const [loader, setLoader] = useState(false);
	const [popupLoading, setPopupLoading] = useState(false);
	const [inLineLoader, setInLineLoader] = useState(false);
	const [showRecallPopup, setShowRecallPopup] = useState(false);
	const [recallReason, setRecallReason] = useState('');
	const [recallReasonText, setRecallReasonText] = useState('');
	const [recallData, setRecallData] = useState(null);
	const [showErrorModal, setShowErrorModal] = useState(false);
	const [isSubmitting, setIsSubmitting] = useState(false);
	const [errorMessage, setErrorMessage] = useState('');
	const [currentPage, setCurrentPage] = useState(1);
	const statusRender = params => {
		const statusConfig = {
			ApprovedCompleted: { bgcolor: 'approvedColor', icon: CheckIcon, text: 'Status.Approved' },
			Pending: { bgcolor: 'pendingColor', icon: ClockIcon, text: 'Status.Pending' },
			Rejected: { bgcolor: 'rejectedColor', icon: DenyIcon, text: 'Status.Rejected' },
			InProgress: { bgcolor: 'inprogressColor', icon: InfoIcon, text: 'Status.InProgress' },
			OnHold: { bgcolor: 'pendingColor', icon: ClockIcon, text: 'Status.OnHold' },
			Recalled: { bgcolor: 'pendingColor', text: 'Status.Recalled' },
			IncompleteDeleted: { bgcolor: 'pendingColor', text: 'Status.IncompleteDeleted' },
			CompletedDeleted: { bgcolor: 'pendingColor', text: 'Status.CompletedDeleted' }
		};
		const normalizedValue = toPascalCase(params.value);
		const config = statusConfig[normalizedValue] || statusConfig[params.value] || statusConfig['Pending'];
		const statusText = props?.submittedRequestData?.GridStatus?.[config.text] || params.value;

		return (
			<div className={`gridStatus ${config.bgcolor}`}>
				{config.icon && <img src={config.icon} className="statusIcon" alt={params.value} />}
				{statusText}
			</div>
		);
	};

	const recallOptions = Object.entries(props?.submittedRequestData?.RecallPopupOptions || {}).map(([key, label]) => ({
		value: key, // stable key like "Other"
		label // translated text from Sitecore
	}));

	function toPascalCase(str) {
		return str
			.replace(/[^a-zA-Z0-9]/g, ' ') // replace non-alphanumeric with spaces
			.replace(/(?:^\w|[A-Z]|\b\w)/g, w => w.toUpperCase()) // capitalize the first character of each word
			.replace(/\s+/g, ''); // remove spaces
	}
	const handleRecall = (data, actionType) => {
		setPopupLoading(true);
		setRecallData({ ...data, actionType });
		setShowRecallPopup(true);
		setRecallReason('');
	};
	const rawPlaceholder =
		props?.submittedRequestData?.GridHeaders?.['Referrals.SubmitttedReferralsList.RecallPopUpOtherPlaceholderText'] ??
		"Please don't include names, contact info or other personal data in this field.";

	const normalizeButton = s => (s ? s.charAt(0).toUpperCase() + s.slice(1).toLowerCase() : s);

	// simple normalization: lower then capitalize first letter
	const normalizedPlaceholder = rawPlaceholder.charAt(0).toUpperCase() + rawPlaceholder.slice(1).toLowerCase();

	const closePopup = () => {
		setShowRecallPopup(false);
		setRecallReason('');
		setPopupLoading(false);
	};
	const submitONHoldRecallReason = async () => {
		setIsSubmitting(true);
		setPopupLoading(true);
		try {
			let response;
			if (recallData.actionType === 'Recall') {
				response = await ReferralsActions.PostRecallRequest({
					...recallData,
					DocumentRejectionReason: recallReason === 'Other' ? recallReasonText : recallReason
				});
			} else if (recallData.actionType === 'StopProcessing') {
				response = await ReferralsActions.PostOnHoldRequest({
					...recallData,
					DocumentRejectionReason: recallReason === 'Other' ? recallReasonText : recallReason
				});
			}
			if (response && (response.status === 200 || response.status === 204)) {
				await getRequestList(currentPage);
			} else {
				await getRequestList(currentPage);
				setErrorMessage(
					"Sorry, we couldn't process your recall request due to a server problem. Please try again or contact support if the issue persists."
				);
				setShowErrorModal(true); // Show error modal popup
			}
		} catch (error) {
			setErrorMessage(
				"Sorry, we couldn't process your recall request due to a server problem. Please try again or contact support if the issue persists."
			);
			setShowErrorModal(true); // Show error modal popup
		} finally {
			setIsSubmitting(false);
			setShowRecallPopup(false);
			setRecallData(null);
			setPopupLoading(false);
			setRecallData(null);
		}
	};
	const recallPopup = (
		<div className="custom-popup-overlay recall-popup-overlay">
			<div className="custom-popup recall-popup-container meeting-form">
				<button className="recall-close-btn" onClick={closePopup} aria-label="Close">
					<img src={imgCloseButton} alt="close" className="close-icon-img" />
				</button>

				<form className="needs-validation" noValidate>
					<h2>{props?.submittedRequestData?.Labels?.['Referrals.SubmitttedReferralsList.RecallPopupTitle']}</h2>
					<div className="recall-options-group mt-5">
						{recallOptions.map(option => {
							const isOther = option.value === 'Other';
							return (
								<label key={option.value} className="recall-option-label d-block my-4">
									<input
										type="radio"
										className="recall-radio-input me-2"
										value={option.value}
										checked={recallReason === option.value}
										onChange={() => {
											setRecallReason(option.value);
											if (!isOther) setRecallReasonText('');
										}}
									/>
									{option.label}
								</label>
							);
						})}
					</div>

					{recallReason === 'Other' && (
						<TextArea
							name="RecallReasonText"
							value={recallReasonText}
							onChange={e => {
								const value = e.target.value;
								if (value.length < 100) {
									setRecallReasonText(value);
								}
							}}
							className="recall-textarea-override"
							placeholder={normalizedPlaceholder}
							style={{ fontSize: '1rem', fontWeight: 400 }}
						/>
					)}

					<div className="meeting-form__buttons mt-4">
						<Button
							type="button"
							buttonClass="button--blue me-md-3"
							onClickHandler={submitONHoldRecallReason}
							disabled={
								isSubmitting ||
								(recallReason !== 'Other' && !recallReason.trim()) ||
								(recallReason === 'Other' && !recallReasonText.trim())
							}>
							{isSubmitting ? <Spinner /> : 'Submit'}
						</Button>
					</div>
				</form>

				<div className="bottoclass">
					<div className="popup-bottom-gradient"></div>
				</div>
			</div>
		</div>
	);

	const documentNameRender = params => {
		const name = params.value?.replace?.('.xlsx', '') || '';

		if (name.length > 35) {
			return <div>{name?.substring?.(0, 35) + '...'}</div>;
		}

		return <div>{name}</div>;
	};

	const dateRender = params => {
		const resDate = customDateConverter(params.value);
		let getDateAndTime = resDate.split(' ');
		return (
			<>
				<div style={{ fontWeight: '600' }}>{getDateAndTime[0]}</div>
				<span>{getDateAndTime[1]}</span>
			</>
		);
	};
	const rejectRender = params => {
		if (params.data?.DocumentStatus === 'Rejected' && params.value != '' && params.value.length > 5) {
			//let dummydata = 'Rejected due to Invalid data found in the sheet';
			let dummydata = params.value;
			return dummydata.substring(0, 30) + '...';
		}
	};
	const submittedByRender = params => {
		if (params.value != '' && params.value.length > 50) {
			let dummydata = params.value;
			return dummydata.substring(0, 50) + '...';
		}
		return params.value;
	};

	const viewActionRender = params => {
		const status = params.data?.DocumentStatus;
		const normalizedStatus = toPascalCase(status);
		if (normalizedStatus === 'Rejected')
			return (
				<div className="viewText">
					<img src={DownlodIcon} className="viewArrow" onClick={() => downloadTemplate()} alt="Download Icon" />
				</div>
			);
		if (normalizedStatus === 'Pending') {
			const recallLabelRaw = props?.submittedRequestData?.GridHeaders?.['Referrals.SubmitttedReferralsList.RecallBtn'];
			const recallLabel = normalizeButton(recallLabelRaw);
			return (
				<div className="actionButtons">
					<button
						className="recallButton d-flex align-items-center justify-content-center"
						onClick={e => {
							e.stopPropagation();
							handleRecall(params.data, 'Recall');
						}}>
						{recallLabel || 'Recall'}
					</button>
				</div>
			);
		}
		if (normalizedStatus === 'InProgress') {
			const stopProcessingRaw =
				props?.submittedRequestData?.GridHeaders?.['Referrals.SubmitttedReferralsList.StopProcessingBtn'];
			const stopProcessingLabel = normalizeButton(stopProcessingRaw);
			return (
				<div className="actionButtons">
					<button
						className="recallButton d-flex align-items-center justify-content-center"
						onClick={e => {
							e.stopPropagation();
							handleRecall(params.data, 'StopProcessing');
						}}>
						{stopProcessingLabel || 'Stop Processing'}
					</button>
				</div>
			);
		}
		return null;
	};

	useEffect(() => {
		let widthData = screenSize.width >= 1920 ? xxlDataForReferral : normalDataForReferral;
		let headers = [
			{
				headerName: props?.submittedRequestData?.GridHeaders?.['Referrals.SubmitttedReferralsList.CandidateName'],
				field: 'DocumentName',
				colId: 'DocumentName',
				width: widthData[0].documentNameWidth,
				cellRenderer: documentNameRender,
				cellStyle: { fontWeight: '600' }
			},
			{
				headerName: props?.submittedRequestData?.GridHeaders?.['Referrals.SubmitttedReferralsList.SubmittedBy'],
				field: 'CreatedBy',
				wrapText: true,
				autoHeight: true,
				width: widthData[0].submittedByWidth,
				cellRenderer: submittedByRender,
				cellStyle: { lineHeight: '24px' }
			},
			{
				headerName: props?.submittedRequestData?.GridHeaders?.['Referrals.SubmitttedReferralsList.AddedDate'],
				field: 'DocumentUploadedTimeStamp',
				width: widthData[0].documentUploadedTimeStampWidth,
				wrapText: true,
				autoHeight: true,
				cellRenderer: dateRender,
				cellStyle: { lineHeight: '24px' }
			},
			{
				headerName: props?.submittedRequestData?.GridHeaders?.['Referrals.SubmitttedReferralsList.Status'],
				field: 'DocumentStatus',
				width: xxlDataForReferral[0].documentStatus,
				cellRenderer: statusRender
			},
			{
				headerName: props?.submittedRequestData?.GridHeaders?.['Referrals.SubmitttedReferralsList.Download'],
				field: 'Actions',
				width: widthData[0].viewActionWidth,
				cellRenderer: viewActionRender,
				cellStyle: {
					justifyContent: 'start',
					alignItems: 'center',
					padding: '0'
				}
			},
			{
				headerName: props?.submittedRequestData?.GridHeaders?.['Referrals.SubmitttedReferralsList.RejectionReason'],
				field: 'DocumentRejectionReason',
				width: widthData[0].documentRejectionReasonWidth,
				cellRenderer: rejectRender,
				tooltipField: 'DocumentRejectionReason',
				tooltipComponentParams: { color: '#ececec' }
			}
		];
		setColumnDefs(headers);
	}, [props.submittedRequestData]);

	const defaultColDef = useMemo(() => ({
		sortable: true,
		resizable: true,
		tooltipComponent: CustomTooltip
	}));

	// Load Submitted Request From API
	useEffect(() => {
		if (shouldLog.current) {
			shouldLog.current = false;
			setInLineLoader(true);
			getRequestList(currentPage);
		}
	}, []);

	const getRequestList = async (pageNum = currentPage) => {
		let payload = { PageNumber: pageNum, PageSize: pageSize };
		await ReferralsActions.GetRequestList(payload).then(async res => {
			if (res.status === 200 && res?.data?.referralUploads?.length > 0) {
				paginateItems(pageNum - 1, res?.data?.referralUploads, res?.data?.TotalCount);
			} else {
				setReferralItems([]);
				setInLineLoader(false);
			}
		});
	};

	//For Paginate
	const [pageCount, setPageCount] = useState(0);
	const [referralItems, setReferralItems] = useState([]);

	const paginateItems = (itemOffset, ReferralList, totalCount) => {
		setReferralItems(ReferralList);
		const pageCount = Math.ceil(totalCount / pageSize);
		setPageCount(pageCount);
		setInLineLoader(false);
	};

	const handlePageClick = async event => {
		setInLineLoader(true);
		const selectedPage = event.selected + 1;
		setCurrentPage(selectedPage);
		await getRequestList(selectedPage);
	};
	//For Paginate

	/* eslint-disable */
	const downloadTemplate = async (filePath, fileName) => {
		const selectedRows = refgridRef.current.api.getSelectedRows();
		setLoader(true);
		if (selectedRows[0].Id) {
			const result = http
				.documentsDownloadGet(
					environments.DOWNLOAD_REFERRAL_API + '/' + selectedRows[0]?.Id + '/' + environments.BRAND_ID
				)
				.then(res => {
					let contentTypeHeader = res.headers['content-type'];
					var blob = new Blob([res.data], {
						type: contentTypeHeader.toLowerCase(),
						charset: 'UTF-8'
					});
					let fileName = selectedRows[0]?.DocumentName;
					let reason = selectedRows[0]?.DocumentRejectionReason;
					console.log('blob', blob);
					saveAs(blob, `${fileName}`);
					downloadTxtFile(reason, fileName);
				})
				.catch(error => {
					console.error('DOWNLOAD ERROR', error.message);
					setLoader(false);
				});
		}
	};
	/* eslint-enable */

	const downloadTxtFile = async (reason, filename) => {
		var blob = new Blob([reason], { type: 'text/plain;charset=utf-8' });
		let NotePadFileNamePrefix =
			props?.submittedRequestData?.GridHeaders['Referrals.SubmitttedReferralsList.RejectionReasonFileName'];
		let extractedfileName = filename.replace('.xlsx', '');
		let reasonNotePadFileName = NotePadFileNamePrefix.replace('FILENAME', extractedfileName.toUpperCase());
		saveAs(blob, `${reasonNotePadFileName}.txt`);
		setLoader(false);
	};

	return (
		<div className="requestList p-sm-3 p-md-0">
			<PopupLoading show={popupLoading} />
			<p className="reqTitle">{props?.submittedRequestData?.GridTitle}</p>
			{loader && <Loader />}
			{!inLineLoader && referralItems ? (
				<Grid
					gridRef={refgridRef}
					columnDefs={columnDefs}
					defaultColDef={defaultColDef}
					rowData={referralItems}
					gridHeight=""
					gridMinHeight={true}
					context={{ handleRecall }}
					fitToScreen={{ key: 'DocumentName', minWidth: 300 }}
				/>
			) : (
				<div className="ag-theme-alpine" style={{ width: '100%', height: 475, marginBottom: 20 }}>
					<InLineLoader />
				</div>
			)}
			{referralItems && (
				<ReactPaginate
					breakLabel="..."
					nextLabel={<img src={RightArrowPaginate} alt="Right Arrow Icon" />}
					onPageChange={handlePageClick}
					pageRangeDisplayed={5}
					pageCount={pageCount}
					previousLabel={<img src={LeftArrowPaginate} alt="Left Arrow Icon" />}
					renderOnZeroPageCount={null}
					breakClassName={'page-item'}
					breakLinkClassName={'page-link'}
					containerClassName={'pagination'}
					pageClassName={'page-item'}
					pageLinkClassName={'page-link'}
					previousClassName={'page-item'}
					previousLinkClassName={'page-link'}
					nextClassName={'page-item'}
					nextLinkClassName={'page-link'}
					activeClassName={'active'}
				/>
			)}
			{/* {snackbarCtx && snackbarCtx.isDisplayed && <Snackbar />} */}
			{showRecallPopup && recallPopup}
			<>
				{/* <Modalpopup
				show={showErrorModal}
				modalSize={'md'}
				onClose={() => setShowErrorModal(false)}
				closeButtonVariant={true}>
				<div>
					<h4>Error9</h4>
					<p>{errorMessage}</p>
					<button onClick={() => setShowErrorModal(false)}>Close</button>
				</div>
			</Modalpopup> */}
				<Modalpopup
					show={showErrorModal}
					modalSize="md"
					// onClose={() => setShowNotificationModal(false)}
					// closeButtonVariant={true}
					className="notification-modal">
					<div className="">
						<h4>Error</h4>
						<p className="pt-2 pl-2">{errorMessage}</p>
						<div className="pt-5">
							<button onClick={() => setShowErrorModal(false)} className="btn btn-outline-primary">
								Close
							</button>
						</div>
					</div>
				</Modalpopup>
			</>
		</div>
	);
}
